export const lizardcardlist = [
  {
    id: 1,
    name: '펫테일게코',
    imgUrl: 'lizard05',
    category: 'category2',
    link: '/fattail-home',
  },
  {
    id: 2,
    name: '레오파드게코',
    imgUrl: 'lizard02',
    category: 'category2',
    link: '/fattail-home',
  },
  {
    id: 3,
    name: '크레스티드게코',
    imgUrl: 'lizard03',
    category: 'category1',
    link: '/fattail-home',
  },
  {
    id: 4,
    name: '리키 에너스',
    imgUrl: 'lizard04',
    category: 'category1',
    link: '/fattail-home',
  },
  {
    id: 5,
    name: '차화 게코',
    imgUrl: 'lizard05',
    category: 'category1',
    link: '/fattail-home',
  },
  {
    id: 6,
    name: '바이퍼 게코',
    imgUrl: 'lizard03',
    category: 'category2',
    link: '/fattail-home',
  },
  {
    id: 7,
    name: '비어디 드래곤',
    imgUrl: 'lizard02',
    category: 'category3',
    link: '/fattail-home',
  },
];
